import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListPayments from '../../components/billing/list-payments.component';

const BillingPaymentsView = () => {
  const pageTitle = 'User Management / Payments';

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListPayments />
    </AppLayout>
  );
};

export default BillingPaymentsView;
